import { TransferAssetItemComponentBase } from './transfer-asset-item.component.base';
import { Component, ElementRef, Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, UserStorage } from '@scisys-uim/uim-common';
import { TRANSFER_ASSET_TYPE } from 'assets-model';
import { AssetService, BusinessUnitService, CostCentreService, TransferAssetService } from 'assets-service';


@Component({
  selector: 'app-transfer-asset-item',
  templateUrl: './transfer-asset-item.component.html',
  styleUrls: ['./transfer-asset-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class TransferAssetItemComponent extends TransferAssetItemComponentBase {

  constructor(protected transferAssetService: TransferAssetService,
    protected assetService: AssetService,
    protected businessUnitService: BusinessUnitService,
    protected costCentreService: CostCentreService,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(transferAssetService, assetService, businessUnitService, costCentreService, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  itemSet() {
    super.itemSet();
    this.assetLoadSelectionList();
    this.businessUnitLoadSelectionList();
    this.costCentreLoadSelectionList();
  }


  setDefaultDisabledFields() {
    super.setDefaultDisabledFields();
    if (!this.form) {
      return;
    }

    this.transferAssetId.disable();
    this.asset.disable();
    this.businessUnit.disable()
    this.costCentre.disable();
    this.createdBy.disable();
    this.dateCreated.disable();
    this.approvedRejectedBy.disable();
    this.approvedRejectedDate.disable();
    this.comments.disable();
  }

  disableApproveRejectButtons() {
    return this.isReadOnly() || this.item.approved != null
      || this.item?.approvalRejectionComment?.length == 0 || this.item?.approvalRejectionComment == null;
  }

  private isReadOnly() {
    return this.createMode || this.readOnly;
  }

  disableApproval() {
    return this.disableApproveRejectButtons();
  }

  disableRejection() {
    return this.disableApproveRejectButtons();
  }

  approveButtonVisible() {
    return !this.isReadOnly();
  }

  rejectButtonVisible() {
    return !this.isReadOnly();
  }

  approvalRejectionTitle() {
    if (this.item?.approved == true) {
      return "Approved"
    }
    if (this.item?.approved == false) {
      return "Rejected"
    }
    return "Approve / Reject"
  }

  markApprovalOrRejection(val: boolean) {
    this.item.approved = val;
    this.item.approvedRejectedBy = this.userDetails?.username;
    this.item.approvedRejectedDate = new Date();
    this.form.updateValueAndValidity();
  }

  currentUserIsCreator(): boolean {
    return this.userDetails?.username == this.item.createdBy;
  }


  assetLoadSelectionList() {
    if (this.createMode) {
      super.assetLoadSelectionList();
    } else {
      if (this.item != null) {
        this.assetSelectionList = [this.item.asset];
      } else {
        this.assetSelectionList = [];
      }
    }
  }

}



